<template>
  <div>
    <p>Cool event here! {{ event.event.id }}</p>
    <b>{{ event.timeText }}</b>
    <i>{{ event.event.title }}</i>
  </div>
</template>

<script>
export default {
  name: "CalendarItem",
  props: {
    event: {
      type: Object,
      required: true,
    }
  },
}
</script>

<style scoped>

</style>
